module.exports = __webpack_public_path__ + "img/instagram-icon.7d0c2ee1.png";